import { App, ErrorNotFound, ErrorUnexpectedResult, } from '@1hive/connect-core';
async function _parseApp(app, organization) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const version = (_a = app.repo) === null || _a === void 0 ? void 0 : _a.versions.sort((v1, v2) => parseInt(v2.semanticVersion.replace(/,/g, '')) -
        parseInt(v1.semanticVersion.replace(/,/g, ''))).find((version) => { var _a; return version.codeAddress === ((_a = app.version) === null || _a === void 0 ? void 0 : _a.codeAddress); });
    const data = {
        address: app.address,
        appId: app.appId,
        artifact: version === null || version === void 0 ? void 0 : version.artifact,
        codeAddress: (_b = app.version) === null || _b === void 0 ? void 0 : _b.codeAddress,
        contentUri: version === null || version === void 0 ? void 0 : version.contentUri,
        isForwarder: app.isForwarder,
        isUpgradeable: app.isUpgradeable,
        kernelAddress: (_c = app.organization) === null || _c === void 0 ? void 0 : _c.address,
        manifest: version === null || version === void 0 ? void 0 : version.manifest,
        name: app.repoName,
        registry: (_e = (_d = app.repo) === null || _d === void 0 ? void 0 : _d.registry) === null || _e === void 0 ? void 0 : _e.name,
        registryAddress: (_g = (_f = app.repo) === null || _f === void 0 ? void 0 : _f.registry) === null || _g === void 0 ? void 0 : _g.address,
        repoAddress: (_h = app.repo) === null || _h === void 0 ? void 0 : _h.address,
        version: version === null || version === void 0 ? void 0 : version.semanticVersion.replace(/,/g, '.'),
    };
    return App.create(data, organization);
}
export async function parseApp(result, organization) {
    var _a;
    const app = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.app;
    if (app === null) {
        throw new ErrorNotFound('No app found.');
    }
    if (!app) {
        throw new ErrorUnexpectedResult('Unable to parse app.');
    }
    return _parseApp(app, organization);
}
export async function parseApps(result, organization) {
    var _a;
    const data = result === null || result === void 0 ? void 0 : result.data;
    const apps = (_a = data === null || data === void 0 ? void 0 : data.organization) === null || _a === void 0 ? void 0 : _a.apps;
    if (!apps || (data === null || data === void 0 ? void 0 : data.organization) === null) {
        throw new ErrorUnexpectedResult('Unable to parse apps.');
    }
    return Promise.all(apps.map(async (app) => {
        return _parseApp(app, organization);
    }));
}
